module.exports = __webpack_public_path__ + "static/media/kerning.50d5f159.svg";